/* eslint-disable react/prop-types */
/* eslint-disable import/prefer-default-export */
import React from 'react'
import AuthModal from 'components/modal/AuthModal'
import s from './ReadyToFind.module.css'
import image1 from './key.jpg'
import image2 from './lock.jpg'
import image3 from './keyAndLock.jpg'

export function ReadyToFind({ signedIn }) {
  return (
    <div className={s.root}>
      <div className={s.imageWrapper1}>
        <img alt="key" src={image1} className={s.image} />
      </div>
      <div className={s.imageWrapper2}>
        <img alt="lock" src={image2} className={s.image} />
      </div>

      <div className={s.mobileImage}>
        <img alt="lock and key" src={image3} className={s.image} />
      </div>

      <div className={s.content}>
        <div className={s.title}>Ready to find your next home?</div>
        <div className={s.text}>Join the Nooklyn community today—sign up now and find your perfect NYC home!</div>
      </div>

      {signedIn ? (
        <a className={s.searchApartments} href="/rentals" target="_blank">
          Search Apartments
        </a>
      ) : (
        <AuthModal>
          <button className={s.signUp} type="button">
            Sign up
          </button>
        </AuthModal>
      )}
    </div>
  )
}
